import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteItem, fetchData, handleDragEnd, toggleStatus, } from "../../../utils/apiUtils";
import { ActionButton, PlusButton, ToggleSwitch } from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import DeleteModel from "../../../Components/DeleteModel";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import debounce from "lodash.debounce";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../helper/Breadcrumb";
import { getNextPosition } from "../../../helper/nextPosition";

const MegaMenu = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const [loading, setLoading] = useState(true);
    const [subMenuData, setsubMenuData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState({});
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [IsDeleting, setIsDeleting] = useState(false)
    const totalPages = Math.ceil(totalCount / perPage);
    const [search, setSearch] = useState("");
    const fetchsubMenuData = async (page = 1, searchQuery = "") => {
        const requestData = {
            perPage: perPage,
            pageNo: page,
            parentId: editData?.id,
            search: searchQuery,
        };
        await fetchData(
            "menu-pagination",
            requestData,
            setsubMenuData,
            setTotalCount,
            setCurrentPage,
            setLoading
        );
    };
    const debouncedFetcCategory = useCallback(
        debounce(fetchsubMenuData, 1000),
        [perPage]
    );

    useEffect(() => {
        if (editData?.id) {
            debouncedFetcCategory(1, search);
        }
    }, [perPage, search]);

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalCount) {
            fetchsubMenuData(page);
        }
    };

    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };


    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("menu", deleteItemId?.id, fetchsubMenuData, []);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (error) {
            return error;
        } finally {
            setIsDeleting(false);
        }
    };


    const handleEditClick = (item) => {
        navigator("/add-submenu", {
            state: item,
        });
    };

    const handleAdd = () => {
        const position = getNextPosition(subMenuData);
        navigator("/add-submenu", {
            state: { parentId: editData?.id, categoryId: editData?.categoryId || null, position: position },
        });
    };

    const handleOnDragEnd = (result) => {
        handleDragEnd({
            result,
            data: subMenuData,
            setData: setsubMenuData,
            apiEndpoint: "/menu-position",
        });
    };

    const handleStatusToggle = async (item) => {
        const data = await toggleStatus("menu-status", item?.id);
        if (Object.keys(data).length > 0) {
            setsubMenuData((prevCategory) =>
                prevCategory.map((curr) =>
                    curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
                )
            );
        }
    };

    const Tableheader = [
        "Name",
        "Type",
        "Active",
        "Action",
    ];

    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Menu", path: "/menu" },
        { label: "SubMenu", path: "/submenu" },
    ];

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5">
                    <h3 className="custom-page-title">{editData?.label} Mega Menu</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div
                    className="d-flex justify-content-between mb-3"
                    style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
                >
                    <select
                        className="form-control form-control-sm w-auto"
                        value={perPage}
                        onChange={(e) => setPerPage(Number(e.target.value))}
                    >
                        {[5, 10, 20, 50, 100, 150].map((limit) => (
                            <option key={limit} value={limit}>
                                {limit}
                            </option>
                        ))}
                    </select>

                    <div style={{ display: "flex", gap: "20px" }}>
                        <div className="search-box">
                            <button className="btn-search">
                                <i className="fas fa-search"></i>
                            </button>
                            <input
                                type="text"
                                className="input-search"
                                placeholder="Type to Search..."
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>

                        <PlusButton handleAdd={handleAdd} module={"Sub Category"} />
                    </div>
                </div>

                <div className="row" style={{ marginTop: "-10px" }}>
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                    <Droppable droppableId="sliders">
                                        {(provided) => (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                className="table-responsive"
                                            >
                                                <table
                                                    className=" custom-table table table-striped"
                                                    cellSpacing="0"
                                                    id="subcategoryTable"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th className="font-weight-bold col-1">#</th>
                                                            {Tableheader.map((item, index) => (
                                                                <th className="font-weight-bold" key={index}>
                                                                    {item}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {loading ? (
                                                            <tr>
                                                                <td colSpan="7" className="text-center">
                                                                    <Spinner />
                                                                </td>
                                                            </tr>
                                                        ) : subMenuData?.length > 0 ? (
                                                            subMenuData?.map((item, id) => {
                                                                return (
                                                                    <Draggable
                                                                        key={item.id}
                                                                        draggableId={item.id.toString()}
                                                                        index={id}
                                                                    >
                                                                        {(provided) => (
                                                                            <tr
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                ref={provided.innerRef}
                                                                            >
                                                                                <td>{item.position}</td>
                                                                                <td >{item?.label}</td>
                                                                                <td >{item?.type}</td>


                                                                                <td >
                                                                                    {
                                                                                        editData?.isMega ? (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="count-button1"
                                                                                                onClick={() => navigator("/mega-menu", { state: item })}
                                                                                            >
                                                                                                {item._count?.children}
                                                                                            </button>
                                                                                        ) : (<span>-</span>)
                                                                                    }


                                                                                </td>



                                                                                <td >

                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            navigator("/menu-image", {
                                                                                                state: { ...item, size: "335 X 160" },
                                                                                            })
                                                                                        } style={{
                                                                                            background: "linear-gradient(135deg, #a3bffa 0%, #6366f1 100%)",
                                                                                            color: "#ffffff",
                                                                                            border: "none",
                                                                                            borderRadius: "10px",
                                                                                            width: "40px",
                                                                                            height: "40px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                                                                                            cursor: "pointer",
                                                                                            transition: "transform 0.2s, box-shadow 0.2s",
                                                                                        }}
                                                                                        onMouseEnter={e => {
                                                                                            e.currentTarget.style.transform = "scale(1.1)";
                                                                                            e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.2)";
                                                                                        }}
                                                                                        onMouseLeave={e => {
                                                                                            e.currentTarget.style.transform = "scale(1)";
                                                                                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa-solid fa-plus" style={{ fontSize: "18px" }}></i>
                                                                                    </button>

                                                                                </td>



                                                                                <td>
                                                                                    <ToggleSwitch
                                                                                        data={item}
                                                                                        name="isActive"
                                                                                        checked={item.isActive}
                                                                                        handleStatusToggle={handleStatusToggle}
                                                                                        module={"Menu"}
                                                                                    />
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <ActionButton
                                                                                        data={item}
                                                                                        handleEditClick={handleEditClick}
                                                                                        handleDelete={handleDelete}
                                                                                        module={"Menu"}


                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </Draggable>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="12" className="text-center">
                                                                    <h4>No data available</h4>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>

                                {subMenuData.length > 0 && (
                                    <div style={{ marginTop: "30px" }}>
                                        <CustomPagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageClick}
                                            perPage={perPage}
                                            totalCount={totalCount}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {deleteModalOpen && (
                <DeleteModel
                    deleteModalOpen={deleteModalOpen}
                    setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                    onConfirm={confirmDelete}
                    itemName="sub Menu"
                    IsDeleting={IsDeleting}
                />
            )}
        </>
    );
};

export default MegaMenu;
